export const Area = [
  {id: 1,	name: 'Unidad de Riesgos'},
  {id: 2,	name: 'Finanzas'},
  {id: 3,	name: 'Operaciones'},
  {id: 4,	name: 'Talento Humano'},
  {id: 5,	name: 'Innovación y Productividad'},
  {id: 6,	name: 'Unidad de Cumplimiento'},
  {id: 7,	name: 'UDEC'},
  {id: 8,	name: 'Gobierno Cooperativo'},
  {id: 9,	name: 'Atención al Afiliado'},
  {id: 10,	name: 'Mercadeo y Publicidad'},
  {id: 11,	name: 'Negocios y Créditos'},
  {id: 12,	name: 'Operaciones'},
  {id: 13,	name: 'Jurídico'},
  {id: 14,	name: 'TI'},
  {id: 15,	name: 'Comunicación e Imagen'},
  {id: 16,	name: 'Cobranzas'},
  {id: 17,	name: 'Unidad de Auditoria'},
];

export const Riesgo = [
  {id: 1,	name: 'Crédito'},
  {id: 2,	name: 'Liquidez'},
  {id: 3,	name: 'Mercado'},
  {id: 4,	name: 'Operativo'},
  {id: 5,	name: 'Estrategico'},
  {id: 6,	name: 'Legal'},
  {id: 7,	name: 'Reputacional'},
  {id: 8,	name: 'Emergente'},
  {id: 9,	name: 'Tecnologico'},
  {id: 10,	name: 'Cumplimiento Normativo'},
  {id: 11,	name: 'Ciberseguridad'},
  {id: 12,	name: 'Riesgo Seguridad de la Informacion'},
  {id: 13,	name: 'Riesgo LA/FT'},
  {id: 14,	name: 'No aplica'},
];

export const Fuente = [
  {id: 1,	name: 'Interna'},
  {id: 2,	name: 'Externa'},
];

export const Perdida = [
  {id: 1,	name: 'Genera Perdidas y Afecta el Estado de Resultados de la CAC'},
  {id: 2,	name: 'Genera Perdidas y no Afecta el Estado de Resultados de la CAC'},
  {id: 3,	name: 'No Genera Perdidas y no Afecta el Estado de Resultados de la CAC'},
];

export const Impacto = [
  {id: 1, name: 'Insignificante'},
  {id: 2, name: 'Menor'},
  {id: 3, name: 'Moderado'},
  {id: 4, name: 'Mayor'},
  {id: 5, name: 'Extremo'},
];

export const Probabilidad = [
  {id: 1,	name: 'Improbable'},
  {id: 2,	name: 'Posible'},
  {id: 3,	name: 'Probable'},
  {id: 4,	name: 'Frecuente'},
  {id: 5,	name: 'Muy Frecuente'},
];

export const Control = [
  {id: 1, name:	'Manual'},
  {id: 2, name:	'Semiautomático'},
  {id: 3, name:	'Automático'},
];

export const Periodicidad = [
  {id: 1, name: 'Permanente'},
  {id: 2, name: 'Periodico'},
  {id: 3, name: 'Ocasional'},
];

export const Oportunidad = [
  {id: 1, name:	'Preventivo'},
  {id: 2, name:	'Correctivo'},
  {id: 3, name:	'Detectivo'},
];

export const EfectividadControl = [
  {id: 1,	name: 'Altamente efectivo'},
  {id: 2,	name: 'Efectivo'},
  {id: 3,	name: 'Aceptable'},
  {id: 4,	name: 'Poco efectivo'},
  {id: 5,	name: 'Inefectivo'},
  {id: 6,	name: 'Inexistente'},
];

export const EstatusPlan = [
  {id: 1, name:	'Gerente de Riesgo'},
  {id: 2, name:	'Gerente de Finanzas'},
  {id: 3, name:	'Gerente de Operaciones '},
  {id: 4, name:	'Gerente de Talento Humano'},
  {id: 5, name:	'Gerente de Innovación'},
  {id: 6, name:	'Gerente de Cumplimiento'},
  {id: 7, name:	'Gerente de UDEC'},
  {id: 8, name:	'Gerente de Gobierno'},
  {id: 9, name:	'Gerente de Atención al Afiliado'},
  {id: 10, name:	'Gerente de Mercadeo y Publicidad'},
  {id: 11, name:	'Gerente de Negocios y Créditos'},
  {id: 12, name:	'Gerente de Operaciones'},
  {id: 13, name:	'Gerente Jurídico'},
  {id: 14, name:	'Gerente de TI'},
  {id: 15, name:	'Gerente de Comunicación e Imagen'},
  {id: 16, name:	'Gerente de Cobranzas'},
  {id: 17, name:	'Auditor Interno'},
];

export const Estatus = [
  {id: 1, name: 'No aplica'},
  {id: 2, name: 'Hasta 20%'},
  {id: 3, name: 'Entre 20% y 50%'},
  {id: 4, name: 'Entre 50% y 80%'},
  {id: 5, name: 'Entre 80% y 99%'},
  {id: 6, name: '100%  Cumplido'},
];

export const Categoria = [
  {id: 1, name: 'Fraude interno', values: [
    {id: 1, name: 'Actividades no autorizadas', values: [
      {id: 1, name: 'Uso indebido de facultades y poderes'},
      {id: 2, name: 'Operaciones no reveladas (intencionalmente)'},
      {id: 3, name: 'Operaciones no autorizadas (con pérdidas monetarias)'},
      {id: 4, name: 'Valoración errónea de posiciones (intencional)'},
    ]},
    {id: 2, name: 'Robo y fraude', values: [
      {id: 1, name: 'Fraude fondos'},
      {id: 2, name: 'Fraude en compras'},
      {id: 3, name: 'Otros Fraudes'},
      {id: 4, name: 'Hurto'},
      {id: 5, name: 'Extorsión'},
      {id: 6, name: 'Malversación'},
      {id: 7, name: 'Robo'},
      {id: 8, name: 'Apropiación indebida de activos'},
      {id: 9, name: 'Destrucción dolosa de activos'},
      {id: 10, name: 'Falsificación'},
      {id: 11, name: 'Utilización de cheques sin fondos'},
      {id: 12, name: 'Contrabando'},
      {id: 13, name: 'Apropiación de cuentas de identidad entre otros'},
      {id: 14, name: 'Evasión de impuestos (intencional)'},
      {id: 15, name: 'Soborno/Cohecho'},
      {id: 16, name: 'Abuso de información privilegiada a favor de terceros'},
    ]},
    {id: 2, name: 'Seguridad de los sistemas', values: [
      {id: 1, name: 'Vulneración de sistemas de seguridad'},
      {id: 2, name: 'Daños por ataques informáticos incluyendo ciberataque'},
      {id: 3, name: 'Robo de información'},
      {id: 4, name: 'Utilización inadecuada de claves de acceso y/o niveles de autorización'},
    ]},
  ]},
  {id: 2, name: 'Fraude externo', values: [
    {id: 1, name: 'Robo y fraude', values: [
      {id: 1, name: 'Hurto'},
      {id: 2, name: 'Robo'},
      {id: 3, name: 'Estafa'},
      {id: 4, name: 'Extorsión'},
      {id: 5, name: 'Soborno'},
      {id: 6, name: 'Falsificación externa'},
      {id: 7, name: 'Suplantación de personalidad'},
      {id: 8, name: 'Utilización fraudulenta de cheques'},
      {id: 9, name: 'Espionaje industrial'},
      {id: 10, name: 'Contrabando'},
    ]},
    {id: 2, name: 'Seguridad de los sistemas', values: [
      {id: 1, name: 'Vulneración de sistemas de seguridad'},
      {id: 2, name: 'Daños por ataques informáticos incluyendo ciberataque'},
      {id: 3, name: 'Robo de información'},
      {id: 4, name: 'Utilización inadecuada de claves de acceso y/o niveles de autorización'},
    ]},
    {id: 2, name: 'Electrónico', values: [
      {id: 1, name: 'Baiting'},
      {id: 2, name: 'Phishing'},
      {id: 3, name: 'Malware'},
      {id: 4, name: 'Ransomware'},
    ]},
  ]},
  {id: 3, name: "Relaciones laborales y seguridad en el puesto de trabajo", values: [
    {id: 1, name: "Relaciones laborales", values: [
      {id: 1, name: "Cuestiones relativas a la remuneración prestaciones sociales (relacionado con despido por parte de la Institución) extinción de contratos y recursos humanos"},
      {id: 2, name: "Organización laboral"}
    ]},
    {id: 2, name: "Higiene y seguridad en el trabajo", values: [
        {id: 1, name: "Responsabilidad en general" },
        {id: 2, name: "Casos relacionados con las normas de higiene y ergonomía" },
        {id: 3, name: "Casos relacionados con la seguridad en el trabajo" }
    ]},
    {id: 3, name: "Diversidad_y_discriminación", values: [
        {id: 1, name: "Todo tipo de discriminación" },
        {id: 2, name: "Invasión a la intimidad o acoso" }
    ]}
  ]},
  {id: 4, name: "Clientes productos y prácticas empresariales", values: [
    {id: 1, name: "Adecuación divulgación de información y confianza", values: [
      {id: 1, name: "Abusos de confianza" },
      {id: 2, name: "Incumplimiento de pautas" },
      {id: 3, name: "Divulgación de información (conocimiento del cliente)" },
      {id: 4, name: "Quebrantamiento de la privacidad de información sobre clientes" },
      {id: 5, name: "Ventas agresivas" },
      {id: 6, name: "Confusión de cuentas" },
      {id: 7, name: "Abuso de información confidencial" }
    ]},
    {id: 2, name: "Prácticas_empresariales_o_de_mercado_improcedentes", values: [
      {id: 1, name: "Prácticas restrictivas de la competencia" },
      {id: 2, name: "Prácticas comerciales o de mercado improcedentes" },
      {id: 3, name: "Manipulación del mercado" },
      {id: 4, name: "Abuso de información privilegiada (a favor de la empresa)" },
      {id: 5, name: "Actividades no autorizadas" },
      {id: 6, name: "Lavado de dinero" }
    ]},
    {id: 3, name: "Productos_defectuosos", values: [
      {id: 1, name: "Defectos del producto" },
      {id: 2, name: "Error de los modelos" }
    ]},
    {id: 4, name: "Selección_patrocinio_y_riesgos", values: [
      {id: 1, name: "Ausencia de investigación a clientes conforme a las directrices" },
      {id: 2, name: "Exceso de los límites de riesgo frente a clientes" }
    ]},
    {id: 5, name: "Actividades_de_asesoramiento", values: [
      {id: 1, name: "Litigios sobre resultados de las actividades de asesoramiento" }
    ]}
  ]},
  {id: 5, name: "Daños a activos materiales", values: [
    {id: 1, name: "Desastres y otros acontecimientos", values: [
      {id: 1, name: "Pérdidas por desastres naturales" },
      {id: 2, name: "Pérdidas por causas externas" },
      {id: 3, name: "Incendios" },
      {id: 4, name: "Temperatura o humedad severas" },
      {id: 5, name: "Interferencia electromagnética" },
      {id: 6, name: "Descarga eléctrica" },
      {id: 7, name: "Explosión" },
      {id: 8, name: "Colisión" },
      {id: 9, name: "Insectos o Roedores" },
      {id: 10, name: "Conflicto Armado" }
    ]}
  ]},
  {id: 6, name: "Interrupción del negocio y fallos en los sistemas", values: [
    {id: 1, name: "Sistemas", values: [
      {id: 1, name: "Falla o mal funcionamiento del Hardware" },
      {id: 2, name: "Falla o mal funcionamiento del Software" },
      {id: 3, name: "Falla o mal función de comunicaciones" },
      {id: 4, name: "Falla en el suministro de energía" },
      {id: 5, name: "Falla en el suministro de agua" },
      {id: 6, name: "Pérdida del soporte de los servicios en outsourcing" },
      {id: 7, name: "Falla en los medios de Almacenamiento" }
    ]}
  ]},
  {id: 7, name: "Otros", values: [
    {id: 1, name: "Otros", values: [
      {id: 1, name: "Otros" }
    ]},
    {id: 2, name: "Eventos_externos", values: [
      {id: 1, name: "Continuidad de negocio sin daño a activos" }
    ]}
  ]}
];

export const Accion = [
  {id: 1, name: 'No amerita acción'},
  {id: 2, name: 'Empleado sancionado'},
  {id: 3, name: 'En proceso de solución'},
  {id: 4, name: 'Solucionado/corregido'},
  {id: 5, name: 'En proceso de investigación'},
  {id: 6, name: 'En litigio'},
  {id: 7, name: 'Litigio ganado'},
  {id: 8, name: 'Litigio perdido'},
  {id: 9, name: 'No se ha realizado nada'}
];

export const Agencia = [
  {id :1, name: 'A'},
  {id :2, name: 'B'},
  {id :3, name: 'C'},
  {id :4, name: 'D'},
  {id :5, name: 'E'},
  {id :6, name: 'F'},
  {id :7, name: 'G'},
  {id :8, name: 'H'},
  {id :9, name: 'I'},
  {id :10, name: 'J'},
  {id :11, name: 'K'},
  {id :12, name: 'L'},
  {id :13, name: 'M'},
  {id :14, name: 'N'}
];

export const EstatusEvento = [
  {id: 1, name: 'Normal'},
  {id: 2, name: 'En validación'},
  {id: 3, name: 'Validado'},
  {id: 4, name: 'No validad'}
];

export const NivelRiesgo = [
  {min: 0, max:	3, name: 'Tolerable'},
  {min: 3, max:	5, name: 'Bajo'},
  {min: 5, max:	9, name: 'Moderado'},
  {min: 9, max:	14, name: 'Relevante'},
  {min: 14, max: 25, name:	'Inaceptable'},

];

export const NivelExpocision = [
  {name: 'Muy bajo', min: 0, max: 0.5},
  {name: 'Bajo', min:	0.5, max: 2.0},
  {name: 'Medio', min:	2.0, max: 6.0},
  {name: 'Alto', min:	6.0, max: 12.0},
  {name: 'Muy Alto', min:	12.0, max: 25.0},
];

export const ControlVal = [
  {id: 95, name:	'Altamente efectivo'},
  {id: 75, name:	'Efectivo'},
  {id: 35, name:	'Poco efectivo'},
  {id: 15, name:	'Inefectivo'},
  {id: 0, name:	'Inexistente'},
];

export const colores = [
  '#4CAF50',
  '#7CE980',
  '#FFEB3B',
  '#FF8300',
  '#F44336'
];

export const valoresInf = [
  [1,2,3,3,4,4],
  [1,2,3,3,4,4],
  [1,2,2,3,4,4],
  [0,1,2,3,3,4],
  [0,1,2,3,3,3],
  [0,1,2,2,3,3],
  [0,1,2,2,3,3],
  [0,1,1,2,2,3],
  [0,1,1,2,2,2],
  [0,1,1,1,2,2],
  [0,1,1,1,1,1],
  [0,0,0,1,1,1],
];
export const valoresSup = [
  [2,3,4,4],
  [2,3,4,4],
  [0,2,3,3],
  [0,0,2,2],
];

export const titulosTab = [
  {nombre: 'Inaceptable', codigo: 16},
  {nombre: 'Inaceptable', codigo: 12},
  {nombre: 'Inaceptable', codigo: 9}, 
  {nombre: 'Relevante', codigo: 8},
  {nombre: 'Relevante', codigo: 6},
  {nombre: 'Moderado', codigo: 4}, 
  {nombre: 'Moderado', codigo: 3},
  {nombre: 'Tolerante', codigo: 2},
  {nombre: 'Tolerante', codigo: 1}
];

export const valoresInf1 = [
  [1,3,4,4,4,4],
  [1,2,4,4,4,4],
  [1,2,3,3,4,4],
  [1,2,3,3,4,4],
  [1,2,3,3,3,3],
  [0,2,3,3,3,3],
  [0,2,2,2,3,3],
  [0,1,2,2,3,3],
  [0,1,2,2,2,2],
  [0,1,2,2,2,2],
  [0,1,2,2,2,2],
  [0,1,1,1,2,2],
  [0,0,1,1,1,1],
  [0,0,1,1,1,1],
];
export const valoresSup1 = [
  [1,3,4,4,4],
  [1,2,3,4,4],
  [0,2,2,3,4],
  [0,1,2,2,3],
  [0,0,0,1,1],
];
export const titulosTab1 = [
  {nombre: 'Inaceptable', codigo: 25},
  {nombre: 'Inaceptable', codigo: 20},
  {nombre: 'Relevante', codigo: 16},
  {nombre: 'Relevante', codigo: 15},
  {nombre: 'Relevante', codigo: 12},
  {nombre: 'Moderado', codigo: 10}, 
  {nombre: 'Moderado', codigo: 9},
  {nombre: 'Moderado', codigo: 8},
  {nombre: 'Bajo', codigo: 6},
  {nombre: 'Bajo', codigo: 5},
  {nombre: 'Bajo', codigo: 4},
  {nombre: 'Tolerante', codigo: 3},
  {nombre: 'Tolerante', codigo: 2},
  {nombre: 'Tolerante', codigo: 1}
];

export const ROLES = {
  ADMIN: 'Rol_Administrador',
  ADMIN_DEMO: 'Rol Administrador_DEMO',
  CARGA: 'Rol_Carga',
  SEGUIMIENTO: 'Rol_Seguimiento',
  ALEEMA: 'Administrador_AleemaRemake',
  VALIDADOR: 'Rol_validador eventos',
  VALIDADOR2: 'Riesgos Master',
  ADMIN_: 'Administrador_AleemaRemake_',
  ADMIN_CLIMA: 'Administrador_Planeacion_ClimaLaboral',
}

export const PERMISOS = {
  ADMINISTRACION_: [
    ROLES.ADMIN_,
    ROLES.ADMIN_CLIMA,
  ],

  ADMINISTRACION: [
    ROLES.ADMIN,
    ROLES.ADMIN_DEMO,
    ROLES.ALEEMA,
    ROLES.ADMIN_CLIMA,
  ],

  CARGA_ARCHIVOS: [
    ROLES.ADMIN,
    ROLES.ADMIN_DEMO,
    ROLES.CARGA,
    ROLES.ALEEMA,
    ROLES.ADMIN_CLIMA,
  ],

  SEGUIMIENTO: [
    ROLES.ADMIN,
    ROLES.ADMIN_DEMO,
    ROLES.CARGA,
    ROLES.SEGUIMIENTO,
    ROLES.ALEEMA,
    ROLES.ADMIN_CLIMA,
  ],

  VALIDACION: [
    ROLES.VALIDADOR,
    ROLES.VALIDADOR2,
  ]
};

export class Valores{
  static getSuperiores(idInstitucion){
    switch(idInstitucion){
      case '65847bdffee1bc001a5f4311':
      case '60762f9a766c0a001a97ec26':
        return valoresSup;
      case '6986445985cc430012f77600':
        return valoresSup1;
    }
    return valoresSup;
  }

  static getInferiores(idInstitucion){
    switch(idInstitucion){
      case '65847bdffee1bc001a5f4311':
      case '60762f9a766c0a001a97ec26':
        return valoresInf;
      case '6986445985cc430012f77600':
        return valoresInf1;
    }
    return valoresInf;
  }
  
  static getTitulosTab(idInstitucion){
    switch(idInstitucion){
      case '65847bdffee1bc001a5f4311':
      case '60762f9a766c0a001a97ec26':
        return titulosTab;
      case '6986445985cc430012f77600':
        return titulosTab1;
    }
    return valoresInf;
  }
}

//Companies
export const companies = [
  {id: '65847bdffee1bc001a5f4311', name: 'Caja Popular Florencio Rosas', suffix: 'MXN'},
  {id: '60762f9a766c0a001a97ec26', name: 'Friedrich Consulting Grup', suffix: 'MXN'},
  // {id: '6931ea5e85cc430012f77552', name: 'ADICLA', suffix: 'Q'},
  {id: '6986445985cc430012f77600', name: 'Chorotega', suffix: 'HNL'},
];
export const companiesRiesgoCredito = [
  // 0 -> sin intereses   1 -> con intereses
  // 0 -> sin agrupacion   1 -> con agrupacion
  {id: '2', name: 'ESPOIR', idAdmin: '66a3054e3c30a400123e1c96', moneda: '$', monedaS: 'dolares', tipoMenu: 1, interes: true, parInclusive: 0},
  {id: '1002', name: 'MBORAYHU', idAdmin: '67a661a45317bc0019d6631a', moneda: 'Gs', monedaS: 'guaraníes', tipoMenu: 0, interes: false, parInclusive: 0},
  {id: '1004', name: 'COOSANCA', idAdmin: '67d303545317bc0019d66397', moneda: 'Gs', monedaS: 'guaraníes', tipoMenu: 0, interes: false, parInclusive: 0},
  {id: '1003', name: 'COOPERSAM', idAdmin: '67a660c55317bc0019d66319', moneda: 'Gs', monedaS: 'guaraníes', tipoMenu: 0, interes: false, parInclusive: 0},
  {id: '2006', name: 'FLORENCIO ROSAS', idAdmin: '65847bdffee1bc001a5f4311', moneda: '$', monedaS: 'pesos mexicanos', tipoMenu: 0, interes: false, parInclusive: 0},
  {id: '1006', name: 'DEMO Paraguay', idAdmin: '68dc246485cc430012f77517', moneda: 'Gs', monedaS: 'guaraníes', tipoMenu: 0, interes: false, parInclusive: 0},
  {id: '2008', name: 'ADICLA', idAdmin: '6931ea5e85cc430012f77552', moneda: 'Q', monedaS: 'quetzales', tipoMenu: 0, interes: false, parInclusive: 0},
  {id: '2007', name: 'Mamoncito', idAdmin: '69a5cd7085cc430012f7764f', moneda: 'RD$', monedaS: 'pesos dominicanos', tipoMenu: 0, interes: false, parInclusive: 0},
  {id: '21', name: 'COOPEDUC', idPlantilla: 7, idAdmin: '666c883f3f6f9a0012b3e263', varPar: 'VT011', moneda: 'Gs', monedaS: 'guaraníes', tipoMenu: 0, interes: false, parInclusive: 0},
  {id: '32', name: 'Chorotega', idPlantilla: 13, idAdmin: '6986445985cc430012f77600', moneda: '$', monedaS: 'pesos mexicanos', tipoMenu: 0, interes: false, parInclusive: 0},
];
export const companiesRiesgoLiquidez = [
  {id: '2008', name: 'ADICLA', idPlantilla: 12, idAdmin: '6931ea5e85cc430012f77552', moneda: 'Q', monedaS: 'quetzales'},
  {id: '21', name: 'COOPEDUC', idPlantilla: 7, idAdmin: '666c883f3f6f9a0012b3e263', moneda: 'Gs', monedaS: 'guaraníes'},
  {id: '2007', name: 'Mamoncito', idPlantilla: 10, idAdmin: '69a5cd7085cc430012f7764f', moneda: 'RD$', monedaS: 'Peso dominicano'},
  {id: '22', name: 'Demo', idPlantilla: 10, idAdmin: '69a5cd7085cc430012f7764f', moneda: 'MXM', monedaS: 'Peso mexicano'},
  {id: '32', name: 'Chorotega', idPlantilla: 13, idAdmin: '6986445985cc430012f77600', moneda: '$', monedaS: 'Peso mexicano', multiMoneda: true, codigoPropio: true},
  // {id: '21', name: 'COOPEDUC', idPlantilla: 7, idAdmin: '666c883f3f6f9a0012b3e263', moneda: 'Gs', monedaS: 'guaraníes'},
];
export const companiesRiesgoCreditoAT = [
  {id: '2', name: 'ESPOIR', idPlantilla: 12, idAdmin: '66a3054e3c30a400123e1c96', },
  {id: '2008', name: 'ADICLA', idPlantilla: 12, idAdmin: '6931ea5e85cc430012f77552', varPar: 'VT11'},
  {id: '21', name: 'COOPEDUC', idPlantilla: 7, idAdmin: '666c883f3f6f9a0012b3e263', varPar: 'VT011'},
  {id: '32', name: 'Chorotega', idPlantilla: 13, idAdmin: '6986445985cc430012f77600', varPar: 'VT011'},
]
export const companiesFinanciero = [
  {id: '21', name: 'COOPEDUC', idPlantilla: 7, idAdmin: '666c883f3f6f9a0012b3e263', multiMoneda: false, codigoPropio: false},
  {id: '23', name: 'MBORAYHU', idPlantilla: 9, idAdmin: '67a661a45317bc0019d6631a', multiMoneda: false, codigoPropio: false},
  {id: '24', name: 'COOPERSAM', idPlantilla: 9, idAdmin: '67a660c55317bc0019d66319', multiMoneda: false, codigoPropio: false},
  {id: '25', name: 'COOSANCA', idPlantilla: 9, idAdmin: '67d303545317bc0019d66397', multiMoneda: false, codigoPropio: false},
  {id: '22', name: 'CREDIGUATE', idPlantilla: 8, idAdmin: '67cf11d75317bc0019d66390', multiMoneda: false, codigoPropio: false},
  {id: '29', name: 'DEMO Paraguay', idPlantilla: 9, idAdmin: '68dc246485cc430012f77517', multiMoneda: false, codigoPropio: false},
  {id: '30', name: 'ADICLA', idPlantilla: 12, idAdmin: '6931ea5e85cc430012f77552', multiMoneda: false, codigoPropio: false},
  {id: '31', name: 'Cooperativa Guatemala', idPlantilla: 8, idAdmin: '69403f6c85cc430012f77597', multiMoneda: false, codigoPropio: false},
  {id: '32', name: 'Chorotega', idPlantilla: 13, idAdmin: '6986445985cc430012f77600', multiMoneda: true, codigoPropio: true},
  {id: '33', name: 'Hipódromo', idPlantilla: 5, idAdmin: '679a7d855317bc0019d66310', multiMoneda: false, codigoPropio: false}
]
export const companiesProyecciones = [
  {id: '60762f9a766c0a001a97ec26', name: 'Friedrich Consulting Grup', clavepais: 'MX'}
]
export const companiesReportesNorm = [
  {id: '32', name: 'Chorotega', idPlantilla: 13, idAdmin: '6986445985cc430012f77600', multiMoneda: true, codigoPropio: true}
]
export const companiesSegPresupuestal = [
  //back 1 -> Manual 0 -> IA
  //idBack corresponde al id que espera el back para identidicar la institucion
  //etiquetas sera un numero que se le asigne a cada institucion para diferenciar las etiquetas personalizables
  // {id: '60762f9a766c0a001a97ec26', idBack: 2, name: 'Friedrich Consulting Grup', clavepais: 'MX', back: 0, etiquetas: 1},
  {id: '6568cfb6fee1bc001a5f42da', idBack: 6, name: 'Tlajomulco', clavepais: 'MX', back: 1, etiquetas: 2},
  {id: '67f6a2df5317bc0019d663d4', idBack: 33, name: 'Tzaulan', clavepais: 'MX', back: 1, etiquetas: 2},
  {id: '679a7d855317bc0019d66310', idBack: 40, name: 'Hipódromo', clavepais: 'MX', back: 1, etiquetas: 2},
  {id: '67acd7c45317bc0019d66342', idBack: 52, name: 'Sagrada Familia', clavepais: 'MX', back: 1, etiquetas: 2}

]

/**
 * maximoClimaLaboral: escala real de la ponderación de clima laboral (cuestionarios
 * anónimos) para esta institución. El back siempre regresa los scores sobre una
 * escala de 0-10 o 0-100; resultados-clima.service.ts hace una regla de tres con este valor
 * para convertirlos a la escala real. Si no se define aquí, se usa un fallback.
 */
export const Instituciones = [
  {id: '6942f0e585cc430012f7759c', name: 'San Pablo', isFederacion: false, maximoClimaLaboral: undefined },
  {id: '6568cfb6fee1bc001a5f42da', name: 'Tlajomulco', isFederacion: false, maximoClimaLaboral: undefined },
  {id: '67cf11d75317bc0019d66390', name: 'Crediguate', isFederacion: false, maximoClimaLaboral: undefined },
  {id: '695d59ce85cc430012f775a5', name: 'Lachao', isFederacion: false, maximoClimaLaboral: undefined },
  {id: '6993f46b85cc430012f77620', name: 'UNIMED', isFederacion: false, maximoClimaLaboral: undefined },
  {id: '6998f11285cc430012f7762c', name: 'Tocoyatl', isFederacion: false, maximoClimaLaboral: undefined },
  {id: '67a661a45317bc0019d6631a', name: 'MBORAYHU', isFederacion: false, maximoClimaLaboral: undefined },
  {id: '60762f9a766c0a001a97ec26', name: 'Friedrich', isFederacion: false, maximoClimaLaboral: undefined },
  {id: '6378207342a33500194f1f13', name: 'Demo', isFederacion: false, maximoClimaLaboral: undefined },
  {id: '6aa33c100f875f0013943a4c', name: 'Cooperativa Prueba CL', isFederacion: false, maximoClimaLaboral: undefined },
]
//60762f9a766c0a001a97ec26
